import "core-js/modules/es6.array.map";
import React from "react";
import Subpage from "./subpage";

var SubpageContainer = function SubpageContainer(_ref) {
  var hasSubpages = _ref.hasSubpages,
      subpages = _ref.subpages,
      children = _ref.children;

  if (hasSubpages) {
    return React.createElement("div", {
      className: "l-content"
    }, subpages.map(function (subpage, i) {
      return React.createElement(Subpage, {
        key: i,
        isActive: subpage.isActive,
        slug: subpage.slug
      }, subpage.children);
    }));
  }

  return React.createElement("div", {
    className: "l-content"
  }, children);
};

export default SubpageContainer;